
import makerjs from "makerjs";/**
* 计算两点间的弦长
* @param {Object} p1 - 第一个点坐标 {x, y}
* @param {Object} p2 - 第二个点坐标 {x, y}
* @returns {number} 弦长值
*/
function calculateChordLength(p1, p2) {
 const dx = p2.x - p1.x;
 const dy = p2.y - p1.y;
 return Math.sqrt(dx*dx + dy*dy);
}
function A54(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, H1 = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h1 = H * 1 * myZoom,
       h = H1 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 = w, x3 = w, y0 = 0, y1 = h1, y2 = h1, y3 = 0,glassH = h, glassW = w;
//注意这里的H和H1  与 h1  h不一样。
var hd=(h-h1)/2;
const p1 = { x: x1, y: y1 };
const p2 = { x: x2, y: y2 };
// const arcLength=h2;
var L=calculateChordLength(p1, p2);
// L：弦长（两点间距离）
// h：拱高（弦中心点到弧的垂直距离）
var r = (L*L + 4*hd*hd)/(8*hd);
   if (h1 !== 0) {
       var TxtH = H;
   }  if (h !== 0) {
  var TxtH1 = "H1="+H1;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA54 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopArcLine":new makerjs.paths.Arc([x1,y1], [x2,y2], r, false, true), 
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomArcLine": new makerjs.paths.Arc([x3, y3], [x0, y0], r, false, true),
       }
   };
   var drawAbnormalShapeA54MarkH1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([w/2, 0-hd], [w/2, h-hd]),
        // "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
        // "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeA54MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x3, y2], [x3+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeA54MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0-hd - markShift], [x3, y3-hd - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0-hd], [x0, y0-hd - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3-hd], [x3, y3-hd - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA54MarkW, TxtW, [x0, y0-hd - 2 * markShift], [x3, y3-hd - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA54MarkH, TxtH, [x3 + 2 * markShift, y2], [x3 + 2 * markShift, y3]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA54MarkH1, TxtH1, [w/2+2*markShift, y0-hd], [w/2+2*markShift, h-hd]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA54: drawAbnormalShapeA54,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA54: drawAbnormalShapeA54,
        drawAbnormalShapeA54MarkH1: drawAbnormalShapeA54MarkH1,
        drawAbnormalShapeA54MarkH:drawAbnormalShapeA54MarkH,
        drawAbnormalShapeA54MarkW:drawAbnormalShapeA54MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A54;